var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMinusCircle({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12.5,
    r: 11.75,
    fill: "#E8F3FF",
    stroke: "#122D62",
    strokeWidth: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.875 13.3125H5.125C5.04212 13.3125 4.96263 13.2796 4.90403 13.221C4.84542 13.1624 4.8125 13.0829 4.8125 13C4.8125 12.9171 4.84542 12.8376 4.90403 12.779C4.96263 12.7204 5.04212 12.6875 5.125 12.6875H18.875C18.9579 12.6875 19.0374 12.7204 19.096 12.779C19.1546 12.8376 19.1875 12.9171 19.1875 13C19.1875 13.0829 19.1546 13.1624 19.096 13.221C19.0374 13.2796 18.9579 13.3125 18.875 13.3125Z",
    fill: "#122D62"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMinusCircle);
export default __webpack_public_path__ + "static/media/minus-circle.5a9bf99dcf34aa71ff3f878e53b18843.svg";
export { ForwardRef as ReactComponent };